import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75de673e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "scanner-container" }
const _hoisted_2 = {
  id: "myVideo",
  poster: "data:image/gif,AAAA",
  ref: "scanner",
  autoplay: "",
  muted: "",
  playsinline: "",
  controls: ""
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "overlay-element" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "laser" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_button = _resolveComponent("ion-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("video", _hoisted_2, null, 512),
      _hoisted_3,
      _hoisted_4,
      _createVNode(_component_ion_button, {
        class: "btn",
        color: "primary",
        onClick: _ctx.refreshCamera
      }, {
        default: _withCtx(() => [
          _createTextVNode("Ricarica camera")
        ]),
        _: 1
      }, 8, ["onClick"])
    ], 512), [
      [_vShow, !_ctx.isLoading]
    ])
  ]))
}